<template>
  <div id="app" :style="{ zoom: zoom }">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      zoom: 0,
    };
  },
  created() {
    var pixelRatio = window.devicePixelRatio;
    this.zoom = pixelRatio / pixelRatio;
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
